import {updateLabelConfig} from '../../../../data/labelInfos/index.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {AMAZON_SFP} from '../../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const LABEL_PROPERTY = 'carrier_pickup'
const VALID_SHIPPER_TYPES = [AMAZON_SFP]

export default function CarrierPickup() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = CarrierPickup.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Carrier Pickup"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

CarrierPickup.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
